module.exports = __webpack_public_path__ + "img/camp_shirt_other5.26688ae4.svg";